
import { reactive, defineComponent } from "vue";
import TypeSelect from "./TypeSelect.vue";
import GithubIcon from "./GithubIcon.vue";
import OHouContent from "./OHouContent.vue";

export default defineComponent({
  components: {
    TypeSelect,
    GithubIcon,
    OHouContent,
  },

  setup() {
    const state = reactive({
      selectingType: false,
      codebooksType: "🥳",
    });

    const localTypeKey = "codebook_type";
    const localType = localStorage.getItem(localTypeKey);

    if (localType != null) {
      state.codebooksType = localType;
    }

    function codebooksTypeChanged(type: string) {
      state.selectingType = false;

      if (type == null) return;

      updateCodebookType(type);
    }

    function updateCodebookType(type: string) {
      state.codebooksType = type;
      localStorage.setItem(localTypeKey, type);
    }

    return {
      state,
      codebooksTypeChanged,
      updateCodebookType,
    };
  },
});
